import onboardingResponseParams from '../common/onboardingResponseParams';
import onboardingResponse from '../common/plainTextMessages/onboardingResponse';

export default onboardingResponse({
  ...onboardingResponseParams.clickup,
  hasMedia: false,
});
